import React from 'react';
import { Box as MuiBox, Button as MuiButton } from '@mui/material';
import { Dialog } from 'components';
import styled from 'styled-components';

import { ReactComponent as Important } from 'assets/images/important.svg';

function ConfirmationDialog(props) {
  const { initialData, close, open } = props;
  const { data } = initialData;

  const descriptions = Array.isArray(data?.description) ? data.description : [data?.description];

  return (
    <Dialog
      isOpen={open}
      onClose={close}
      close={close}
      data-id="confirmation-dialog"
    >
      <div style={{ maxWidth: 350 }}>
        <MuiBox
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Important style={{ height: 100, width: 100 }} />
          {
            descriptions.map(d => (
              <SDescription>
                {d}
              </SDescription>
            ))
          }
        </MuiBox>
        <MuiBox
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            marginTop: '20px',
          }}
        >
          <MuiButton
            data-id="confirmation-dialog-cancel-button"
            size="small"
            color="primary"
            variant="outlined"
            onClick={() =>
              close({
                isConfirmed: false,
                callbackData: data?.callbackData,
                type: data?.type,
              })
            }
          >
            {data?.cancelText}
          </MuiButton>

          <MuiButton
            data-id="confirmation-dialog-confirm-button"
            size="small"
            color="primary"
            variant="contained"
            onClick={() =>
              close({
                isConfirmed: true,
                callbackData: data?.callbackData,
                type: data?.type,
              })
            }
          >
            {data?.confirmText}
          </MuiButton>
        </MuiBox>
      </div>
    </Dialog>
  );
}

const SDescription = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  &+& {
    margin-top: 8px;
  }
`;

export default ConfirmationDialog;
